import { render, staticRenderFns } from "./CarouselImageOverlay.vue?vue&type=template&id=38cc0744&scoped=true&"
import script from "./CarouselImageOverlay.vue?vue&type=script&lang=js&"
export * from "./CarouselImageOverlay.vue?vue&type=script&lang=js&"
import style0 from "./CarouselImageOverlay.vue?vue&type=style&index=0&id=38cc0744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cc0744",
  null
  
)

export default component.exports